import React, { useEffect } from "react";
import TopBar from "./TopBar";
import SideBar from "./SideBar";
import MainContent from "./MainContent";
import Drawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import Sidebar2 from "./SideBar2";
import { useState } from "react";
import Navbar from "./Navbar";
import { Route, Routes, useNavigate } from "react-router-dom";
import BasicBars from "./BarGraph";
import {
  CssBaseline,
  Typography,
  Box,
  Grid,
  Stack,
  Container,
} from "@mui/material";
import AttendanceTable from "./AttendanceTable";
import AttendanceCalendar from "./AttendanceCalendar";
import DailyAttendanceReport from "./DailyAttendanceReport";
import ReportTable from "./ReportTable";
import EnhancedTable from "./EnhancedTable";
import ReportsWrapper from "./ReportsWrapper";
import ReportSelector from "./ReportSelector";
import StatusCardWrapper from "./StatusCardWrapper";
import StatsCard from "./StatusCard";
import { useUser } from "../Contexts/UserContext";
import CalendarComponent from "./CalendarComponent";
import EventCalendar from "./EventCalendar";
import UpcomingEvents from "./UpcomingEvents";
import Loader from "./Loader";
import FeedbackBarGraph from "./FeedbackBarGraph";
import FeedbackCard from "./FeedbackCard";
import RepairCard from "./RepairCard";
import ModalCard from "./ModalCard";
import DifferentLength from "./LineChart";
import BasicBars2 from "./BasicBars2";
import FeedbackList from "./FeedbackList";
import MaxAttendanceCard from "./AttendanceCard";
import Button from "./Chart";
import MyBarChart from "./MyBarChart";
import ERPDrillCompleted from "./ERPDrill";
import SiteVisit from "./SiteVisit";
import RMGraph from "./RMGraph";
import MaterialsGraph from "./MaterialsGraph";
import AutoRefreshCards from "./AutoRefreshCards";

const drawerWidth = 240;
const units = [
  { id: 1, name: "Unit A" },
  { id: 2, name: "Unit B" },
  { id: 3, name: "Unit C" },
];
const repairData2 = [
  {
    companyId: "GU-4",
    ClientCode: "1353",
    SiteCode: "UNTAPS009482",
    Checklist_name: "A.C",
    dbtime: "2024-06-17T11:00:34.627Z",
  },
  {
    companyId: "GU-4",
    ClientCode: "1353",
    SiteCode: "UNTAPS009482",
    Checklist_name: "Carpentary",
    dbtime: "2024-06-14T10:47:04.800Z",
  },
  {
    companyId: "GU-4",
    ClientCode: "1353",
    SiteCode: "UNTAPS009482",
    Checklist_name: "Electrical(Major)",
    dbtime: "2024-06-17T10:50:30.220Z",
  },
  {
    companyId: "GU-4",
    ClientCode: "1353",
    SiteCode: "UNTAPS009482",
    Checklist_name: "Electrical(Minor)",
    dbtime: "2024-06-17T10:50:30.130Z",
  },
  {
    companyId: "GU-4",
    ClientCode: "1353",
    SiteCode: "UNTAPS009482",
    Checklist_name: "Plumbing",
    dbtime: "2024-06-14T10:47:04.710Z",
  },
];
const data = [
  {
    Lable: "June 2024",
    Good: 10,
    Bad: 1,
    "Very Good": 19,
  },
  {
    Lable: "July 2024",
    Good: 14,
    Bad: 1,
    "Very Good": 35,
  },
  {
    Lable: "August 2024",
    Good: 2,
    Bad: 0,
    "Very Good": 2,
  },
];

const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
function Dashboard() {
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [feedbacks, setFeedbacks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);
  const [cardData, setCardData] = useState({
    TotalSites: 0,
    TotalUsers: 0,
    ActiveUsers: 0,
    DeepCleaning: 0,
    PestControl: 0,
    Materials: 0,
    ActiveUsersArr: [],
    TotalUsersArr: [],
    ERP: 0,
    SitesOpen: 0,
    DailyCleaning: 0,
    FoVisitReport: 0,
    Thermography: 0,
  });
  const [repairData, setRepairData] = useState([]);
  const { user } = useUser();
  const { ClientId, CompCode } = user;

  useEffect(() => {
    const fetchInitData = async () => {
      try {
        const response = await fetch(
          `${API_URL}/facility/get-facility-cards-data/1/${CompCode}/${ClientId}/:fromDate/:toDate`,
        ).then((res) => res.json());

        const getRepairDataResponse = await fetch(
          `${API_URL}/facility/GetRepairMaintenanceData/1/${CompCode}/${ClientId}/UNTAPS009482`,
        ).then((res) => res.json());

        const feedbackResponse = await fetch(
          `${API_URL}/facility/GetFeedBackData/1/${CompCode}/${ClientId}/UNTPFS00008511/1`,
        ).then((res) => res.json());

        if (feedbackResponse.success) {
          setFeedbacks(feedbackResponse.data);
        } else {
          // console.log(`Feedback Msg: ${feedbackResponse.message}`);
        }

        if (getRepairDataResponse.success) {
          setRepairData(getRepairDataResponse.data);
        } else {
          // console.log(getRepairDataResponse.message);
        }

        if (response.success) {
          const {
            TotalSites,
            TotalUsers,
            ActiveUsers,
            DeepCleaning,
            PestControl,
            WashroomCleaning,
            Materials,
            ERP,
            SitesOpen,
            DailyCleaning,
            FoVisitReport,
            Thermography,
          } = response.data;
          let count = 0;
          let tUsers = 0;
          TotalUsers.forEach((ele) => {
            tUsers += ele.Count;
          });
          ActiveUsers.forEach((ele) => {
            count += ele.Count;
          });
          setCardData({
            TotalSites,
            TotalUsers: tUsers,
            ActiveUsers: count,
            DeepCleaning,
            PestControl,
            WashroomCleaning,
            Materials: Materials,
            ActiveUsersArr: ActiveUsers,
            TotalUsersArr: TotalUsers,
            ERP: ERP,
            SitesOpen: SitesOpen,
            DailyCleaning: DailyCleaning,
            FoVisitReport: FoVisitReport,
            Thermography: Thermography,
          });
          setIsLoading(false);
        } else {
          // console.log("Unable to load the dashboard data :(");
          setIsLoading(false);
        }
      } catch (error) {
        // alert("An error occurred while fetching data: " + error.message);
        setIsLoading(false);
      }
    };

    fetchInitData();
  }, [CompCode, ClientId]);
  const handleDrawerToggle = () => {
    setSidebarOpen(!isSidebarOpen);
  };
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const handleFetchReports = (unit, from, to) => {
    // console.log("Fetching reports for:", unit.name, "from", from, "to", to);
    // Fetch reports logic here
  };
  return (
    <>
      <Grid
        container
        direction="column"
        sx={{
          padding: "2rem 4rem",
          width: "100%",
          overflow: "hidden",
        }}
        // spacing={1}
      >
        <Grid sx={{ width: "100%" }} xs={12} item>
          <Stack textAlign="start">
            <h2
              className="heading2"
              style={{
                fontSize: "14px",
                fontWeight: "500",
                padding: "0",
                lineHeight: "1px",
                margin: "0px 0px 0px 0vw",
                letterSpacing: "2px",
                textTransform: "uppercase",
                color: "#aaaaaa",
                fontFamily: "Poppins, sans-serif",
              }}
            >
              Dashboard
              <style>
                {`
      .heading2::after {
        content: "";
    width: 120px;
    height: 1px;
    display: inline-block;
    background: #D10101;
    margin: 4px 10px;
      }
    `}
              </style>
            </h2>
          </Stack>
        </Grid>
        <Grid sx={{ width: "100%" }} xs={12} item>
          {isLoading ? (
            <Loader />
          ) : (
            <Grid sx={{ width: "100%" }} xs={12} container>
              <Grid
                item
                xs={12}
                // sm={6}
                // md={4} // Adjust how many items appear per row
                sx={{
                  boxSizing: "border-box", // Include padding/border in the size calculation
                  marginBottom: "16px", // Add spacing between rows
                  // border: "2px solid black",
                  display: "inline-block",
                  // border: "5px solid blue",
                }}
                fullWidth
              >
                <StatusCardWrapper>
                  {/* <Grid item>
                    <AutoRefreshCards />
                  </Grid> */}
                  <Grid item>
                    <StatsCard
                      title="Total Sites"
                      subtitle="Active Sites"
                      number={cardData.TotalSites}
                      classNames="c1"
                      activeBtn={true}
                    />
                  </Grid>
                  <Grid item>
                    {/* <StatsCard
                    title="Attendance (D)"
                    subtitle="Active Users"
                    number={`${cardData.ActiveUsers}/${cardData.TotalUsers}`}
                    classNames="c2"
                    activeBtn={true}
                  /> */}
                    <MaxAttendanceCard
                      title="Attendance (D)"
                      subtitle="Active Users"
                      number={`${cardData.ActiveUsers}/${cardData.TotalUsers}`}
                      arr={cardData.ActiveUsersArr}
                      arr2={cardData.TotalUsersArr}
                      classNames="c2"
                      activeBtn={true}
                    />
                  </Grid>
                  {ClientId !== "11613" &&
                    ClientId !== "11621" &&
                    ClientId !== "CL0975_01" && (
                      <Grid item>
                        {ClientId !== "11542" ? (
                          <ERPDrillCompleted number={cardData.ERP} />
                        ) : (
                          <SiteVisit number={cardData.ERP} />
                        )}
                      </Grid>
                    )}
                  {ClientId === "1353" && (
                    <>
                      <Grid item>
                        <StatsCard
                          title="Wash Room (D)"
                          subtitle="Reports Submitted"
                          // number={cardData.PestControl}
                          number={`${cardData.WashroomCleaning}
                        `}
                          classNames="c3"
                          activeBtn={false}
                        />
                      </Grid>
                      <Grid item>
                        <StatsCard
                          title="Materials (M)"
                          subtitle="Orders"
                          // number={cardData.PestControl}
                          number={`${cardData.Materials}/${cardData.TotalSites}`}
                          classNames="material"
                          activeBtn={true}
                        />
                      </Grid>
                      <Grid item>
                        <StatsCard
                          title="Deep Cleaning(2xM)"
                          subtitle="Reports Submitted"
                          // number={cardData.DeepCleaning}
                          number={`${cardData.DeepCleaning}/${
                            cardData.TotalSites * 2
                          }`}
                          classNames="c4"
                          activeBtn={false}
                        />
                      </Grid>
                    </>
                  )}
                  {(ClientId === "1008" ||
                    ClientId === "11554" ||
                    ClientId === "1495" ||
                    ClientId === "11613" ||
                    ClientId === "11621") && (
                    <>
                      {ClientId !== "11613" && ClientId !== "11621" ? (
                        <Grid item>
                          <StatsCard
                            title="Wash Room (D)"
                            subtitle="Reports Submitted"
                            // number={cardData.PestControl}
                            number={`${cardData.WashroomCleaning}/${cardData.TotalSites}`}
                            classNames="washroom"
                            activeBtn={true}
                          />
                        </Grid>
                      ) : (
                        <Grid item>
                          <StatsCard
                            title="Daily Cleaning (D)"
                            subtitle="Reports Submitted"
                            // number={cardData.PestControl}
                            number={`${cardData.DailyCleaning}/${cardData.TotalSites}`}
                            classNames="dailyCleaning"
                            activeBtn={true}
                          />
                        </Grid>
                      )}
                      {ClientId === "11621" && (
                        <StatsCard
                          title="Ele.Health Checkup"
                          subtitle="Reports Submitted"
                          // number={cardData.PestControl}
                          number={`${cardData.Thermography}/${cardData.TotalSites}`}
                          classNames="thermo"
                          activeBtn={true}
                        />
                      )}
                      <Grid item>
                        <StatsCard
                          title="Deep Cleaning(2xM)"
                          subtitle="Reports Submitted"
                          // number={cardData.DeepCleaning}
                          number={`${cardData.DeepCleaning}/${
                            cardData.TotalSites * 2
                          }`}
                          classNames="deep"
                          activeBtn={true}
                        />
                      </Grid>
                      {ClientId !== "11613" && ClientId !== "11621" && (
                        <Grid item>
                          <StatsCard
                            title="Materials (M)"
                            subtitle="Orders"
                            // number={cardData.PestControl}
                            number={`${cardData.Materials}/${cardData.TotalSites}`}
                            classNames="material"
                            activeBtn={true}
                          />
                        </Grid>
                      )}
                    </>
                  )}
                  {ClientId == "1008" && (
                    <Grid item>
                      <StatsCard
                        title="Fo Visit Rport"
                        subtitle="Reports Submitted"
                        // number={cardData.DeepCleaning}
                        number={`${cardData.FoVisitReport}/${cardData.TotalSites}`}
                        classNames="foVisit"
                        activeBtn={true}
                      />
                    </Grid>
                  )}
                  {ClientId == "CL0975_01" && (
                    <Grid item>
                      <StatsCard
                        title="Deep Cleaning"
                        subtitle="Reports Submitted"
                        // number={cardData.DeepCleaning}
                        number={`${cardData.DeepCleaning}/${cardData.TotalSites}`}
                        classNames="deep"
                        activeBtn={true}
                      />
                    </Grid>
                  )}
                  {ClientId !== "1008" &&
                    ClientId !== "11554" &&
                    ClientId !== "1495" &&
                    ClientId !== "1353" &&
                    ClientId !== "11613" &&
                    ClientId !== "11621" &&
                    ClientId != "CL0975_01" && (
                      <>
                        <Grid item>
                          <StatsCard
                            title="Deep Cleaning"
                            subtitle="Reports Submitted"
                            // number={cardData.DeepCleaning}
                            number={`${cardData.DeepCleaning}/${cardData.TotalSites}`}
                            classNames="deep"
                            activeBtn={true}
                          />
                        </Grid>
                        <Grid item>
                          <StatsCard
                            title="Pest Control"
                            subtitle="Reports Submitted"
                            // number={cardData.PestControl}
                            number={`${cardData.PestControl}/${cardData.TotalSites}`}
                            classNames="pest"
                            activeBtn={true}
                          />
                        </Grid>
                        <Grid item>
                          <StatsCard
                            title="Materials"
                            subtitle="Reports Submitted"
                            // number={cardData.PestControl}
                            number={`${cardData.Materials}/${cardData.TotalSites}`}
                            classNames="material"
                            activeBtn={true}
                          />
                        </Grid>
                      </>
                    )}

                  {(ClientId == "11621" || ClientId == "11613") && (
                    <Grid item>
                      <StatsCard
                        title="Pest Control Rpt"
                        subtitle="Reports Submitted"
                        // number={cardData.PestControl}
                        number={`${cardData.PestControl}/${cardData.TotalSites}`}
                        classNames="pestRpt"
                        activeBtn={true}
                      />
                    </Grid>
                  )}
                  {ClientId == "11613" && (
                    <StatsCard
                      title="Branch Open(D)"
                      subtitle="Reports Submitted"
                      // number={cardData.PestControl}
                      number={`${cardData.SitesOpen}/${cardData.TotalSites}`}
                      classNames="sitesOpen"
                      activeBtn={true}
                    />
                  )}
                </StatusCardWrapper>
              </Grid>
              {/* <Stack
              direction={{
                xs: "column",
                sm: "row",
              }}
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                // width: "100%",
                // height: "280px",
              }}
              spacing={1}
            >
               <FeedbackCard feedbacks={ClientId === "11542" ? feedbacks : []} />
              <UpcomingEvents />
            </Stack> */}
              <Grid item xs={12}>
                <Grid
                  container
                  direction="row"
                  sx={{ height: "280px" }}
                  spacing={1}
                  fullWidth
                >
                  {ClientId === "11542" && (
                    <>
                      <Grid item sm={6} md={4}>
                        {/* <FeedbackCard feedbacks={feedbacks} /> */}
                        <FeedbackList data={[]} />
                      </Grid>
                      <Grid item sm={6} md={5}>
                        {/* <BasicBars /> */}
                        {/* <MyBarChart data={data} /> */}
                      </Grid>
                    </>
                  )}
                  {ClientId !== "11542" && (
                    <>
                      {ClientId !== "11613" && ClientId !== "11621" ? (
                        <Grid item sm={6} md={4}>
                          <FeedbackList data={[]} />
                        </Grid>
                      ) : (
                        <>
                          <Grid item sm={6} md={6}>
                            <RMGraph />
                          </Grid>
                          <Grid item sm={2} md={6}>
                            {ClientId == "11621" || ClientId == "11613" ? (
                              <MaterialsGraph />
                            ) : (
                              <></>
                            )}
                          </Grid>
                        </>
                      )}

                      <Grid item sm={6} md={5}>
                        {/* <BasicBars /> */}
                        {ClientId !== "11613" && ClientId !== "11621" && (
                          <BasicBars2 />
                        )}
                      </Grid>
                    </>
                  )}
                  {/* <Grid item sm={6} md={3}>
                    {ClientId !== "11613" && ClientId !== "11621" && (
                      <UpcomingEvents />
                    )}
                  </Grid> */}
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>

        <Grid item xs={12} mt={2} sx={{ width: "100%" }} fullWidth>
          <Grid container spacing={3} sx={{ height: "280px" }}>
            <Grid item sm={4}>
              {ClientId !== "11613" && ClientId !== "11621" && (
                <RepairCard feedbacks={repairData} />
              )}
            </Grid>
            <Grid item sm={4}>
              {/* <RMGraph /> */}
            </Grid>
            <Grid item sm={4}>
              {ClientId !== "11613" && ClientId !== "11621" && (
                <CalendarComponent />
              )}
              {/* <CalendarComponent /> */}
              {/* <MyBarChart /> */}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default Dashboard;
